import request from '@/utils/request'
import { uuid } from 'vue-uuid';
import { obj2query } from '@/utils'

export function getIfxv2SubAccounts(query) {
  return request({
    url: `/api/ifxv2-subaccounts${obj2query(query)}`,
    method: "get"
  });
}

export function checkIfxv2SubAccountStatus(id) {
  return request({
    url: `/api/ifxv2-subaccounts/${id}/status`,
    method: "post",
    data: { idempotency: uuid.v1() }
  });
}

export function resendIfxv2SubAccount(id) {
  return request({
    url: `/api/ifxv2-subaccounts/${id}/resend`,
    method: "post",
    data: { idempotency: uuid.v1() }
  });
}
